import { Fragment, useContext, useState, useEffect, useRef } from "react";
import { useDispatch, useSelector } from "react-redux";
import { useLocation } from "react-router-dom";
import "../@core/scss/base/plugins/extensions/ext-component-tour.scss";
import "../@core/scss/base/plugins/extensions/ext-component-toastr.scss";
import "../@core/scss/base/plugins/extensions/ext-component-tree.scss";
import "../@core/scss/base/plugins/extensions/ext-component-swiper.scss";
import { getAuth } from "../redux/selectors";
import { handleTour } from "../redux/layout";
import classnames from "classnames";
import { ShepherdTour, ShepherdTourContext } from "react-shepherd";

import { useTourSteps } from "../utility/hooks/useTourSteps";
import {
    handleContentWidth,
    handleMenuCollapsed,
    handleMenuHidden,
    handleShowTour,
    handleStartVideo,
} from "../redux/layout";
import "shepherd.js/dist/css/shepherd.css";
// --------------------------------------------
import Modal from "react-modal";
import x_mark from "../@core/assets/img/x-solid.svg";
import tourVideo from "../@core/assets/video/tour.mp4";

const customStyles = {
    content: {
        top: "50%",
        left: "58%",
        right: "auto",
        bottom: "auto",
        transform: "translate(-50%, -50%)",
        background: "#F9FAFC 0% 0% no-repeat padding-box",
        padding: "5px 20px 20px 20px ",
        width: "50%",
        zIndex: "9000",
        maxHeight: "80vh",
        overflowY: "auto",
    },
};
const tourOptions = {
    defaultStepOptions: {
        cancelIcon: {
            enabled: true,
        },
    },
    useModalOverlay: true,
};
const TourAutoStart = (props) => {
    const dispatch = useDispatch();
    const showTour = useSelector((state) => state.layout.showTour);
    const startVideo = useSelector((state) => state.layout.startVideo);
    const tour = useContext(ShepherdTourContext);
    const currentPath = window.location.pathname;

    const startAutoPlayVideo = (pathname) => {
        dispatch(handleStartVideo(true));
        dispatch(handleShowTour(false));
    };

    const checkLocalStorage = (pathname) => {
        const storageKey = `tour-${pathname}`;
        if (!localStorage.getItem(storageKey) && !props.modalIsOpen) {
            if (props.userData.role == "instructor") {
                tour.start();
            } else if (props.steps?.length > 0 || showTour) {
                startAutoPlayVideo();
            }
            if (
                (currentPath == "/accountingFlashcard" ||
                    currentPath == "/createNote" ||
                    currentPath == "/accountingTest") &&
                (!startVideo || startVideo == undefined)
            ) {
                tour.start();
                dispatch(handleStartVideo(false));
            }
            localStorage.setItem(storageKey, new Date().getTime());
        }
    };

    useEffect(() => {
        if (!startVideo && showTour) {
            tour.start();
            dispatch(handleStartVideo(false));
            dispatch(handleTour(false));
            dispatch(handleShowTour(false));
        }
    }, [showTour]);

    useEffect(() => {
        checkLocalStorage(props.path);

        return () => {
            tour.hide();
        };
    }, [props.path, props.tourValue]);
    return null;
};

const LayoutWrapper = (props) => {
    const tourValue = useSelector((state) => state.layout.tour);
    const showTour = useSelector((state) => state.layout.showTour);
    const startVideo = useSelector((state) => state.layout.startVideo);

    const location = useLocation();
    const { userData } = useSelector(getAuth);
    const steps = useTourSteps(props.path, userData.role);
    const [modalIsOpen, setIsOpen] = useState(false);
    const { layout, children, appLayout, wrapperClass, routeMeta } = props;
    const videoRef = useRef(null);
    const shadowRef = useRef(null);
    const dispatch = useDispatch();
    const store = useSelector((state) => state);
    const contentWidth = store.layout.contentWidth;

    const Tag = layout === "HorizontalLayout" && !appLayout ? "div" : Fragment;

    const cleanUp = () => {
        if (routeMeta) {
            if (routeMeta.contentWidth) {
                dispatch(handleContentWidth("full"));
            }
            if (routeMeta.menuCollapsed) {
                dispatch(handleMenuCollapsed(!routeMeta.menuCollapsed));
            }
            if (routeMeta.menuHidden) {
                dispatch(handleMenuHidden(!routeMeta.menuHidden));
            }
        }
    };

    useEffect(() => {
        if (routeMeta) {
            if (routeMeta.contentWidth) {
                dispatch(handleContentWidth(routeMeta.contentWidth));
            }
            if (routeMeta.menuCollapsed) {
                dispatch(handleMenuCollapsed(routeMeta.menuCollapsed));
            }
            if (routeMeta.menuHidden) {
                dispatch(handleMenuHidden(routeMeta.menuHidden));
            }
        }
        return () => cleanUp();
    }, []);

    useEffect(() => {
        if (startVideo == true) {
            dispatch(handleShowTour(true)); //avelacrel em
            dispatch(handleStartVideo(false)); //avelacrel em
            setIsOpen(false); //avelacrel em
            // openModal(); //sa petq e het bacel
        }
    }, [startVideo]);

    function openModal() {
        setIsOpen(true);
    }
    function closeModal() {
        setIsOpen(false);
        dispatch(handleStartVideo(false));
        dispatch(handleShowTour(true));
    }
    return (
        <div>
            <Modal
                isOpen={modalIsOpen}
                onRequestClose={closeModal}
                style={customStyles}
                ariaHideApp={false}
                contentLabel="Example Modal"
            >
                <div className="closeModalXMark">
                    <h3>Smart Study Tutorial</h3>
                    <img
                        src={x_mark}
                        onClick={closeModal}
                        className="closeModalImg"
                    />
                </div>
                <div>
                    <video
                        ref={videoRef}
                        autoPlay
                        controls
                        style={{
                            width: "100%",
                        }}
                    >
                        <source src={tourVideo} type="video/mp4" />
                    </video>
                </div>
            </Modal>

            <ShepherdTour steps={steps} tourOptions={tourOptions}>
                <div
                    className={classnames("app-content content", {
                        [wrapperClass]: wrapperClass,
                    })}
                >
                    <div className="content-overlay"></div>

                    <div
                        className={classnames({
                            "content-wrapper": !appLayout,
                            "content-area-wrapper": appLayout,
                            "container-xxl p-0": contentWidth === "boxed",
                        })}
                    >
                        <Tag
                            /*eslint-disable */
                            {...(layout === "HorizontalLayout" && !appLayout
                                ? {
                                      className: classnames({
                                          "content-body": !appLayout,
                                      }),
                                  }
                                : {})}
                            /*eslint-enable */
                        >
                            <TourAutoStart
                                path={props.path}
                                tourValue={tourValue}
                                showTour={showTour}
                                modalIsOpen={modalIsOpen}
                                setIsOpen={setIsOpen}
                                steps={steps}
                                userData={userData}
                            />
                            {children}
                        </Tag>
                    </div>
                </div>
            </ShepherdTour>
        </div>
    );
};

export default LayoutWrapper;
